import React, { useState } from 'react';
import SearchBar from './SearchBar';
import MovieCard from './MovieCard';
import MovieModal from './MovieModal';
import { searchMovies } from '../../services/api';
import { handleError } from '../../utils/errorHandler';
import './MovieFinder.css';

const MovieFinder = () => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async (query) => {
    if (!query.trim()) return;

    setIsLoading(true);
    setError(null);
    setHasSearched(true);
    setResults([]);

    try {
      const response = await searchMovies(query);
      setResults(response.data);
    } catch (err) {
      const errorMessage = handleError(err);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const resetToLanding = () => {
    setResults([]);
    setError(null);
    setHasSearched(false);
    setSelectedMovie(null);
    setSearchQuery(''); // Clear the search query
  };

  return (
    <div className="movie-finder">
      <div className="content">
        <div className={`search-section ${!hasSearched ? 'centered' : ''}`}>
          <h1 
            onClick={resetToLanding} 
            className="title-button" 
            role="button" 
            tabIndex={0}
          >
            Movie Finder
          </h1>
          <SearchBar 
            onSearch={handleSearch} 
            isLoading={isLoading} 
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>

        {isLoading && (
          <div className="loader-container">
            <div className="loader" />
          </div>
        )}
        
        {error && <div className="error-message">{error}</div>}
        
        {hasSearched && !isLoading && results.length === 0 && (
          <div className="no-results">No results found. Try a different search term.</div>
        )}

        <div className="movies-grid">
          {results.map((movie, index) => (
            <MovieCard
              key={index}
              movie={movie}
              onClick={() => setSelectedMovie(movie)}
            />
          ))}
        </div>

        {selectedMovie && (
          <MovieModal
            movie={selectedMovie}
            onClose={() => setSelectedMovie(null)}
          />
        )}
      </div>

      <div className="ai-powered">AI-powered</div>
    </div>
  );
};

export default MovieFinder;